<template>
  <div>
    <v-data-table :footer-props="users.footerProps" :page.sync="page" :options.sync="options" :server-items-length="1" :headers="users.headers"
                  :items="users.values" :loading="loading" :loading-text="$t('tableLoadingLabel')">
      <template #item.active="{item}">
        {{item.active ? $t('trueLabel') : $t('falseLabel') }}
      </template>
      <template #item.locked="{item}">
        {{item.locked ? $t('trueLabel') : $t('falseLabel') }}
      </template>
      <template #item.userType="{item}">
        {{$t(getUserTypeLabel(item.userType))}}
      </template>
      <template #item.actions="{ item }">
        <v-btn min-width="100px" v-if="item.locked" @click="
                  () => {
                    selectedUser = item;
                    isLock = false;
                    isUnlock = true;
                    lockUserDialog = true;
                  }
                " class="white--text" small color="green my-2">
          <v-icon left class="mr-4"> mdi-account-cog </v-icon>
          {{ $t("unlockLabel") }}
        </v-btn>
        <v-btn min-width="100px" v-else class="white--text" @click="
                  () => {
                    selectedUser = item;
                    isLock = true;
                    isUnlock = false;
                    lockUserDialog = true;
                  }" small color="red my-2">
          <v-icon left class="mr-4"> mdi-account-cog </v-icon>
          {{ $t("lockLabel") }}
        </v-btn>
        <template>
          <v-btn min-width="100px" class="ml-4 primary--text" small outlined
                 :to="{ name: 'SalesPartnerCompanyDetails' , params: {companyId: companyId, userId: item.id} }">{{ $t("viewUserLabel") }}</v-btn>
        </template>
      </template>
      <template v-slot:no-data>
        {{$t('noDataAvailable')}}
      </template>
      <template v-slot:no-results>
        {{$t('noDataAvailable')}}
      </template>
    </v-data-table>
    <v-pagination v-model="page" :length="pageCount" @input="filter()"></v-pagination>

    <v-dialog v-model="lockUserDialog" max-width="800px">
      <v-card class="pa-10">
        <v-card-title class="justify-center">
          <span class="headline">{{isLock ? $t("lockUserLabel") : $t("unlockUserLabel")}}</span>
        </v-card-title>

        <v-card-text v-if="isLock">
          <v-container>
            <v-row>
              <p class="body-1 text-center">
                {{ $t("lockUserText") }}
              </p>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-text v-else>
          <v-container>
            <v-row>
              <p class="body-1 text-center">{{ $t("unlockUserText") }}</p>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="d-flex justify-center align-center">
          <v-btn v-if="isLock" min-width="150" class="white--text px-10" color="red" @click="lockUser()">
            {{ $t("lockUserLabel") }}
          </v-btn>

          <v-btn v-else min-width="150" class="white--text px-10" color="green" @click="unlockUser()">
            {{ $t("unlockUserLabel") }}</v-btn>

          <v-btn min-width="150" class="primary px-2" color="" @click="() => (lockUserDialog = false)">
            {{ $t("cancelLabel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {getUserTypeLabel} from "@/auth/userTypes"

export default {
  name: "SalesPartnershipUsersTable",
  props: {
    companyId: Number
  },
  data(){
    return{
      getUserTypeLabel: getUserTypeLabel,
      loading: false,
      options: {},
      page: 1,
      pageCount: 1,
      amount: 5,
      sortBy: '',
      sortDesc: null,
      selectedUser: {},
      isLock: false,
      isUnlock: false,
      lockUserDialog: false,
      users: {
        headers: [
          {
            text: this.$t('usersNameLabel'),
            value: 'userFullName',
          },
          {
            text: this.$t('usersPersonalNoLabel'),
            value: 'personalNo',
          },
          {
            text: this.$t('usersEmailLabel'),
            value: 'email',
          },
          {
            text: this.$t('userTypeColumnLabel'),
            value: 'userType',
          },
          {
            text: this.$t('usersStatusLabel'),
            value: 'active',
          },
          {
            text: this.$t('usersLockedLabel'),
            value: 'locked',
          },
          {
            text: '',
            sortable: false,
            value: 'actions',
            align: 'end'
          },
        ],
        values: [],
        footerProps:{
          'items-per-page-options' : [5, 10, 15, 20, -1],
          'disable-pagination': true,
          'next-icon': null,
          'prev-icon': null,
          'page-text' : '',
          'items-per-page-all-text': this.$t('allLabel'),
          'items-per-page-text': this.$t('rowsPerPageLabel')
        }
      },
      snackbar: {
        show: true,
        message: "",
      }
    }
  },
  watch: {
    options: {
      handler(){
        const options = this.options;
        this.amount = options.itemsPerPage
        const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : '';
        const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : null;
        this.sortBy = sortBy;
        this.sortDesc = sortDesc;
        this.getUsers();
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['getUserType', 'getCurrentUser'])
  },
  methods: {
    getUsers(){
      this.loading = true;

      this.axios
          .get("api/user/getbycompanyandhierarchytype", {
            params: {
              page: this.page,
              amount: this.amount,
              sortBy: this.sortBy,
              sortDesc: this.sortDesc
            }
          })
          .then((response) => {
            this.pageCount = response.data.pages;
            this.users.values = response.data.users;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => this.loading = false);
    },
    lockUser() {
      let data = {
        Id: this.selectedUser.id,
      };
      this.axios
          .post("api/user/lockuser", data)
          .then((response) => {
            let index = this.users.values
                .map((item) => {
                  return item.id;
                })
                .indexOf(this.selectedUser.id);
            this.users.values.splice(index, 1, response.data);
            this.selectedUser = {};
            this.isLock = false;
            this.isUnlock = false;
            this.lockUserDialog = false;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    unlockUser() {
      let data = {
        Id: this.selectedUser.id,
      };
      this.axios
          .post("api/user/unlockuser", data)
          .then((response) => {
            let index = this.users.values
                .map((item) => {
                  return item.id;
                })
                .indexOf(this.selectedUser.id);

            this.users.values.splice(index, 1, response.data);
            this.selectedUser = {};
            this.isLock = false;
            this.isUnlock = false;
            this.lockUserDialog = false;
          })
          .catch((error) => {
            console.log(error);
          });
    },
  },
  mounted() {
    this.getUsers()
  }
}
</script>

<style scoped>

</style>